import React, { useCallback, useContext, useState } from 'react'
import tokens from 'config/constants/tokens'
import { useTranslation } from 'contexts/Localization'
import { CardFooter, Button, Text, useModal, AutoRenewIcon } from 'vvs-uikit'
import { Link } from 'react-router-dom'
import { useWeb3React } from '@web3-react/core'
import { useUserVvsBoost } from 'state/xVvs/hooks'
import useVvsBoostHandlers from 'views/xVvs/hooks/useVvsBoostHandlers'
import { useERC20 } from 'hooks/useContract'
import xVvsContext, { Step } from 'views/xVvs/context'
import ConnectWalletButton from 'components/ConnectWalletButton'
import useInvalidateBoostedFarms from 'views/Farms/hooks/useInvalidateBoostedFarms'
import LockModal from '../LockModal'

const DepositXvvsButton = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const xVvsContract = useERC20(tokens.xvvs.address)

  const { setStep, onReset } = useContext(xVvsContext)
  const [requestedApproval, setRequestedApproval] = useState<boolean>()
  const [openLockModal] = useModal(<LockModal customOnDismiss={onReset} />)

  const handleOpenLockModal = () => {
    setStep(Step.SELECT_LOCKING_PERIOD)
    openLockModal()
  }

  const { boostData } = useUserVvsBoost()
  const { allowance } = boostData

  const { onApprove } = useVvsBoostHandlers()
  const { onInvalidatingBoostedFarms } = useInvalidateBoostedFarms()

  const handleApprove = useCallback(async () => {
    try {
      setRequestedApproval(true)
      await onApprove(xVvsContract)
      onInvalidatingBoostedFarms()

      setRequestedApproval(false)
    } catch (e) {
      console.error(e)
    }
  }, [onApprove, xVvsContract, onInvalidatingBoostedFarms])
  return (
    <CardFooter style={{ textAlign: 'center' }}>
      {!account ? (
        <ConnectWalletButton scale="lg" width="100%" />
      ) : allowance && allowance.isGreaterThan('0') ? (
        <Button id="join-pool-button" scale="lg" as={Link} to="#" width="100%" onClick={handleOpenLockModal}>
          <Text textTransform="capitalize" color="white" bold as="h2">
            {t('deposit xVVS')}
          </Text>
        </Button>
      ) : (
        <Button
          scale="lg"
          variant="primary"
          width="100%"
          mb="8px"
          onClick={handleApprove}
          isLoading={requestedApproval}
          endIcon={requestedApproval ? <AutoRenewIcon spin color="currentColor" /> : null}
        >
          {t('Enable')}
        </Button>
      )}
    </CardFooter>
  )
}

export default DepositXvvsButton
